// Build identifier. Update this string on every code change so we can verify
// exactly which build each environment (Preview vs Production) is serving.
// If REACT_APP_BUILD_ID is injected at build time it takes precedence.
export const BUILD_ID =
  process.env.REACT_APP_BUILD_ID || "2026-06-28T17:30Z-adminnotify";

if (typeof window !== "undefined") {
  // Visible in the browser console in ANY environment
  // eslint-disable-next-line no-console
  console.log(
    "%c[Elite Coaching] BUILD_ID:",
    "color:#D4AF37;font-weight:bold",
    BUILD_ID
  );
}
